import { Fragment, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { Navigation, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTab from 'eco-design/elements/eco-tab';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import gtm from 'eco-design-reliance/gtm';

const B = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('costsaving-new');
    const [selectIndex, setSelectIndex] = useState(0);
    const solarEnergyRef = useRef<HTMLDivElement>(null);
    const swiperRef = useRef<any>(null);


    // 点击切换
    const onTabChange = (item: any, index: number) => {
        if (index === selectIndex) {
            return;
        }
        setSelectIndex(index);

        swiperRef.current?.slideTo(index);
    };
    const tabs = [
        {
            title: t(`B_tab1_title`),
            label: t(`B_tab1_title`),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1768186913332/Frame%202094654827.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1768186914065/Frame%202094654830.jpg',
            },
            id: '#solarEnergy',
        },
        {
            title: t(`B_tab2_title`),
            label: t(`B_tab2_title`),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1768186912893/Frame%202094654646.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1768186913844/Frame%202094654831.jpg',
            },
            id: '#rooftop',
        },
        {
            title: t(`B_tab3_title`),
            label: t(`B_tab3_title`),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1768186914214/Frame%202094654828.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1768186913668/Frame%202094654832.jpg',
            },
            id: '#wholeHome',
        },
    ];
    const tabItems = [
        {
            tabValue: t('B_tab1_title'),
            tabLabel: t('B_tab1_title'),
        },
        { tabValue: t('B_tab2_title'), tabLabel: t('B_tab2_title'), },
        { tabValue: t('B_tab3_title'), tabLabel: t('B_tab3_title'), },
    ];


    const handleSlideChange = (swiper: any) => {
        setSelectIndex(swiper.realIndex);
    }
    useCardsShowHook('.solar-energy-container .CardsShow', '.solar-energy-container');
    return (
        <section
            className={`cost-saving-B GtmModuleData-section`}
            id="cost-saving-B"
            data-section-id={'cost-saving-B'}
            data-section-title={t('B_title')}
        >

            <EcoSpace />
            <div className={styles['solar-energy-solutions']} ref={solarEnergyRef} id="solarEnergy">

                <div className="solar-energy-container">
                    <div className="text-info CardsShow">
                        <h2 className='title'>{t('B_title')}</h2>
                        <p className="desc">{t(`B_desc`)}</p>
                    </div>
                    <Swiper
                        className='CardsShow'
                        slidesPerView={'auto'}
                        centeredSlides
                        spaceBetween={12}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        modules={[Navigation]}
                        loop={true}
                        onSlideChange={handleSlideChange}
                        onSwiper={(swiperIns: any) => swiperRef.current = swiperIns}
                    >
                        {tabs.map((item: any, index: number) => (
                            <SwiperSlide key={index} className="swiper-slide solar-energy-img-container ">

                                <EcoImg className="item-img" pc={item.img.pc} pad={item.img.h5} ></EcoImg>

                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="B-tabs-box">
                    <div className="B-tabs">
                        {/* 滑块 */}
                        <div
                            className="B-tabs-indicator"
                            style={{
                                transform: `translateX(${selectIndex * 100}%)`,
                            }}
                        />

                        {tabs.map((i, idx) => (
                            <div className={`B-tabs-item  B-tabs-item-${idx + 1} ${idx === selectIndex ? 'active' : ''}`} onClick={() => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'tab_click',
                                    list_name: t('B_title'),
                                    button_name: i.label,
                                    __btn_id1: `B-tabs-box .B-tabs-item-${idx + 1}`,
                                    __btn_id2: i.label,
                                    __btn_type: 'text',
                                });
                                if (idx === selectIndex) {
                                    return;
                                }
                                setSelectIndex(idx);

                                swiperRef.current?.slideTo(idx);
                            }} key={idx}>
                                {i.label}
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>

    );
};

export default B;
